import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'lightenColor',
	standalone: true
})
export class LightenColorPipe implements PipeTransform {
	transform(color: string, percent: number = 0.8): unknown {
		if (!color.startsWith('#')) return color;

		const num: number = parseInt(color.slice(1), 16);
		const r: number = (num >> 16) & 0xff;
		const g: number = (num >> 8) & 0xff;
		const b: number = num & 0xff;

		const newR: number = Math.min(255, Math.floor(r + (255 - r) * percent));
		const newG: number = Math.min(255, Math.floor(g + (255 - g) * percent));
		const newB: number = Math.min(255, Math.floor(b + (255 - b) * percent));

		return `rgb(${newR}, ${newG}, ${newB})`;
	}
}